import { getIn } from 'final-form';

import { DEFAULT_UNIT_CONFIG, DEFAULT_UNIT_LABEL } from './constants';
import {
  DurationUnit,
  DurationUnitKey,
  Preset,
  ResolvedDurationUnit,
} from './types';

type DeriveActivePresetArgs = {
  values: Record<string, unknown>;
  presets: Preset[];
  fieldNames: Record<DurationUnitKey, string>;
  normalizedUnits: ResolvedDurationUnit[];
};

export const resolveUnit = (
  unit: DurationUnitKey | DurationUnit
): ResolvedDurationUnit => {
  if (typeof unit === 'string') {
    const defaults = DEFAULT_UNIT_CONFIG[unit];

    return {
      key: unit,
      formAccessor: unit,
      min: defaults.min,
      max: defaults.max,
      label: DEFAULT_UNIT_LABEL[unit],
    };
  }

  const defaults = DEFAULT_UNIT_CONFIG[unit.key];

  return {
    key: unit.key,
    formAccessor: unit.formAccessor ?? unit.key,
    min: unit.min ?? defaults.min,
    max: unit.max ?? defaults.max,
    label: unit.label ?? DEFAULT_UNIT_LABEL[unit.key],
  };
};

export const findMatchingPreset = ({
  values,
  presets,
  fieldNames,
  normalizedUnits,
}: DeriveActivePresetArgs): Preset | null => {
  return (
    presets.find((preset) =>
      normalizedUnits.every(({ key }) => {
        return (getIn(values, fieldNames[key]) || 0) === (preset[key] || 0);
      })
    ) ?? null
  );
};
